import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, Stack, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import dayjs from 'dayjs';
import getTimeZone from '../../common/getTimeZone';
const MeetingInfoBar = ({ meeting, }) => {
    // const tokens = useTokens();
    const duration = meeting.status === 'COMPLETED' ? meeting.actualDuration : meeting.plannedDuration;
    const startTime = meeting.startsAt ? `${dayjs(meeting.startsAt).format('lll')} ${getTimeZone()}` : 'Not Scheduled';
    return (_jsx(Stack, { direction: "row", divider: _jsx(Divider, { orientation: "vertical", flexItem: true }), sx: { marginY: 'auto', width: 1 }, justifyContent: "space-between", alignItems: "center", children: [
            startTime,
            `${duration}m`,
        ].map((text, index) => (_jsx(Typography
        // eslint-disable-next-line react/no-array-index-key
        , { component: "div", className: "courseDisplayCourseInfoBarText", children: text }, index))) }));
};
export default observer(MeetingInfoBar);
//# sourceMappingURL=MeetingInfoBar.js.map